import { handleCookie } from '@utils';

import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';
import { userActions } from '@modules/user';

import { checkActionsType } from './utils';

const { setCookie, removeCookie } = handleCookie;

export const cookieSetter: TMiddleware = () => next => action => {
  const actionsWithTokenResponse = [
    loginActions.verifyPassword.fulfilled,
    loginActions.verifyPhone.fulfilled,
    loginActions.verifyEmail.fulfilled,
    userActions.changePassword.fulfilled,
    userActions.changePhoneVerifyPhone.fulfilled,
    userActions.changeEmailVerifyEmail.fulfilled,
    userActions.changeNewPassword.fulfilled,
    userActions.editUser.fulfilled,
    userActions.toggleStrongSecurity.fulfilled,
  ];

  const token = action?.payload?.data?.token;

  if (checkActionsType(action, actionsWithTokenResponse) && IS_DEV && token) {
    setCookie('token', token);
    const idleTimeout = action?.payload?.data?.timeout;
    if (idleTimeout) setCookie('idleTimeout', idleTimeout, { expires: 365 });
  }
  const shouldRemoveToken = [userActions.getUserData.rejected, loginActions.logout.fulfilled];

  if (checkActionsType(action, shouldRemoveToken)) removeCookie('token');
  return next(action);
};

export default cookieSetter;
